/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CartItem } from './cart-item';
import { CustomProductDto } from './custom-product-dto';
import { ManualDiscountDto } from './manual-discount-dto';
import { ManualShippingDto } from './manual-shipping-dto';
/**
 * 
 * @export
 * @interface ManualOrderDTO
 */
export interface ManualOrderDTO {
  _id?: string;
    /**
     * 
     * @type {Array<CartItem>}
     * @memberof ManualOrderDTO
     */
    items?: Array<CartItem>;
    /**
     * 
     * @type {string}
     * @memberof ManualOrderDTO
     */
    notes?: string;
    /**
     * 
     * @type {ManualDiscountDto}
     * @memberof ManualOrderDTO
     */
    manualDiscount: ManualDiscountDto;
    /**
     * 
     * @type {string}
     * @memberof ManualOrderDTO
     */
    discountId: string;
    /**
     * 
     * @type {ManualShippingDto}
     * @memberof ManualOrderDTO
     */
    manualShipping: ManualShippingDto;
    /**
     * 
     * @type {Date}
     * @memberof ManualOrderDTO
     */
    paymentDueDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ManualOrderDTO
     */
    chargeTax: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ManualOrderDTO
     */
    orderRemindingDates: Array<string>;
    /**
     * 
     * @type {Array<CustomProductDto>}
     * @memberof ManualOrderDTO
     */
    customProducts?: Array<CustomProductDto>;
    /**
     * 
     * @type {string}
     * @memberof ManualOrderDTO
     */
    paymentMethod: ManualOrderDTOPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof ManualOrderDTO
     */
    orderStatus: ManualOrderDTOOrderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ManualOrderDTO
     */
    paymentStatus?: ManualOrderDTOPaymentStatusEnum;
    /**
     * If true, skips email verification (admin creating order on behalf of user)
     * @type {boolean}
     * @memberof ManualOrderDTO
     */
    isManualOrder?: boolean;
    /**
     * Stripe PaymentMethod ID collected from the storefront card step. When provided, the order is charged immediately instead of sending an invoice.
     * @type {string}
     * @memberof ManualOrderDTO
     */
    paymentMethodId?: string;
    /**
     * Send order confirmation email to the customer. Defaults to true.
     * @type {boolean}
     * @memberof ManualOrderDTO
     */
    sendConfirmationEmail?: boolean;
    /**
     * Send invoice email to the customer when a Stripe invoice is created. Defaults to true.
     * @type {boolean}
     * @memberof ManualOrderDTO
     */
    sendInvoiceEmail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManualOrderDTO
     */
    deliveryMethod?: ManualOrderDTODeliveryMethodEnum;
    /**
     * User address ID for custom delivery orders
     * @type {string}
     * @memberof ManualOrderDTO
     */
    userAddressId?: string;
    /**
     * Inline delivery address for custom delivery — used when the user has no saved address yet (e.g. guest checkout price preview)
     * @type {any}
     * @memberof ManualOrderDTO
     */
    deliveryAddress?: any;
}

/**
    * @export
    * @enum {string}
    */
export enum ManualOrderDTOPaymentMethodEnum {
    Cash = 'Cash',
    Credit = 'Credit',
    Card = 'Card'
}
/**
    * @export
    * @enum {string}
    */
export enum ManualOrderDTOOrderStatusEnum {
    Pending = 'Pending',
    PickingPacking = 'Picking & Packing',
    ReadyForPickup = 'Ready for Pickup',
    PickedUp = 'Picked Up',
    OutForDelivery = 'Out for Delivery',
    Delivered = 'Delivered',
    OnHold = 'On Hold',
    Cancelled = 'Cancelled'
}
/**
    * @export
    * @enum {string}
    */
export enum ManualOrderDTOPaymentStatusEnum {
    Paid = 'Paid',
    Unpaid = 'Unpaid'
}
/**
    * @export
    * @enum {string}
    */
export enum ManualOrderDTODeliveryMethodEnum {
    Shippo = 'shippo',
    Custom = 'custom',
    Pickup = 'pickup'
}

